module.exports = __webpack_public_path__ + "assets/retina_4thProportionalDetailed.d1a7b124c5ff669ffd17b62acaba03f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_4thProportionalDetailed.png
// module id = 602
// module chunks = 0